export const getColumnClassName = (columnCount: number = 1) : string => { 
        switch( columnCount )
        {
            case 2:
                return " col-md-6 " 
            case 3:
                return " col-md-4 "
            case 4:
                return " col-md-3 "
            case 1:
            default:                
                return " col-12 " 

        } 
}